// extracted by mini-css-extract-plugin
export default {"wrap":"CellSkeleton_wrap__yXHOT","shimmer":"CellSkeleton_shimmer__iuUKs"};